import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/home';
  
  // State to track if sidebar is expanded
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  
  // State to track if we're on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Callback function for sidebar to communicate its expanded state
  const handleSidebarExpand = (expanded) => { 
    setIsSidebarExpanded(expanded);
  };

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // If switched to mobile view, collapse sidebar
      if (mobile && !isMobile && isSidebarExpanded) {
        setIsSidebarExpanded(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, isSidebarExpanded]);

  // Set appropriate background class based on route
  const backgroundClass = isHomePage 
    ? "background h-screen font-montserrat" 
    : "background h-screen overflow-hidden font-montserrat";

  return (
    <div className={backgroundClass}>
      <Header />
      
      {/* Sidebar with handler to communicate expansion state */}
      <Sidebar onExpandChange={handleSidebarExpand} />
      
      {/* Main content with margin that adjusts based on sidebar expansion */}
      <div className={`flex h-screen pt-16 ${isSidebarExpanded ? 'sm:ml-64' : 'sm:ml-16'} transition-all duration-300`}>
        {/* Content container with proper constraints to prevent overflow */}
        <div className="w-full max-w-full overflow-hidden">
          <main className="h-full overflow-auto p-4">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;